import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "🔥 Burned Forever", value: 10, color: "#ec4899" },
  { name: "💧 Locked Liquidity", value: 50, color: "#60a5fa" },
  { name: "🏛️ Treasury Wallet", value: 10, color: "#a78bfa" },
  { name: "📢 Marketing", value: 15, color: "#facc15" },
  { name: "🎁 Giveaway Vault", value: 15, color: "#34d399" },
];


const TokenomicsChart = () => {
  return (
    <div className="flex flex-col items-center">
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={100}     // ✅ donut effect
            outerRadius={160}    // ✅ 50% larger
            dataKey="value"
            nameKey="name"
            isAnimationActive={true}
            animationDuration={800}
            paddingAngle={2}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
  contentStyle={{
    backgroundColor: "#1e0520", // deep purple
    borderColor: "#ec4899",     // match your pink
    borderRadius: "8px",
    color: "#fff",
    fontWeight: "500",
  }}
  itemStyle={{
    color: "#fff",               // ✅ bright white text
    fontSize: "14px",
  }}
  formatter={(value, name) => [`${value}%`, name]}
/>

          
        </PieChart>
      </ResponsiveContainer>
              <p className="text-lg md:text-xl font-semibold text-white text-center max-w-2xl mx-auto mb-6">
  Here’s where $STBOX goes from day one — no secrets, no fluff. Burned tokens keep the supply tight. Locked liquidity keeps trading fair. And the rest? That’s what we use to grow the game and keep things moving.
</p>



      {/* Grid-style Legend */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6 w-full max-w-xl">
        {data.map((item, index) => (
          <div
            key={index}
            className="flex items-center justify-between bg-white/5 px-4 py-3 rounded-lg border border-white/10"
          >
            <div className="flex items-center gap-3">
              <div
                className="w-4 h-4 rounded-full"
                style={{ backgroundColor: item.color }}
              ></div>
              <span className="text-white/90 font-medium">{item.name}</span>
            </div>
            <span className="text-white/60 font-semibold">{item.value}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TokenomicsChart;
